(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.tab-link').forEach(button => {
        button.addEventListener('click', () => {
            const sidePanel = button.closest('.tabs');
            const target = button.getAttribute('data-target');
            sidePanel.querySelectorAll('.tab-content').forEach(tab => {
                tab.style.display = 'none';
            });
            sidePanel.querySelector(target).style.display = 'block';

            sidePanel.querySelectorAll('.tab-link').forEach(btn => {
                btn.classList.remove('active');
            });
            button.classList.add('active');

            if (target === '#tabpage_JzQkGE') {
                document.querySelector('#shopify-section-template--22058585391409__faq_CxxLmt').style.display = 'block';
            } else {
                document.querySelector('#shopify-section-template--22058585391409__faq_CxxLmt').style.display = 'none';
            }
        });
    });

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelector('.tab-content').style.display = 'block';
        document.querySelector('#shopify-section-template--22058585391409__faq_CxxLmt').style.display = 'none';

        const params = new URLSearchParams(window.location.search);
        const tabParam = params.get('tab');
        const service = params.get('service');

        console.log('params - test', params, tabParam, service);

        const tabMap = {
            'repairs': 'tabpage_4fxeh8',
            'buying': 'tabpage_JzQkGE',
            'custom': 'tabpage_9QBy9M',
            'engraving': 'tabpage_fEMgxJ',
            'appraisal': 'tabpage_HgHbaJ'
        };

        if (tabParam && tabMap[tabParam]) {
            const tabId = tabMap[tabParam];
            const targetTabLink = document.querySelector(`.tab-link[data-target="#${tabId}"]`);
            if (targetTabLink) {
                targetTabLink.click();

                setTimeout(() => {
                    const targetTabContent = document.getElementById(tabId);
                    if (targetTabContent) {
                        targetTabContent.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 200); // Adjust the timeout duration if necessary
            }
        }
    });

  } catch(e) { console.error(e); }
})();
})();
